'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { getRichText } from 'FormsUI/selectors/FormDefinition';
import { canUngroupRichText, getIsRichTextUngrouped } from 'FormsUI/selectors/Richtext';
import { updateRichText as updateRichTextFromAction } from 'FormsUI/actions/FormDefinition';
import toggleRichtextUngroup from 'FormsUI/actions/toggleRichtextUngroup';
import RichTextEditor from 'FormsUI/loadable/AsyncRichTextEditor';
import ConfigurationPanelHeader from 'FormsUI/components/editor/form/configuration/ConfigurationPanelHeader';
import { ConfigPanelWrapper } from 'FormsUI/components/editor/form/configuration/ConfigPanelWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class RichTextConfigurationPanel extends PureComponent {
  /* eslint-disable-next-line hubspot-dev/no-static-get-default-props */
  static get defaultProps() {
    return {
      richText: {
        content: ''
      }
    };
  }
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.initialContent = props.richText.content;
  }
  langKey(suffix) {
    return `editor.form.config.richText.${suffix}`;
  }
  handleChange(value) {
    const {
      updateRichText,
      richText,
      richTextId
    } = this.props;
    const newRichText = Object.assign({}, richText, {
      content: value
    });
    updateRichText(richTextId, {
      richText: newRichText
    });
  }
  render() {
    const {
      toggleGrouping,
      canUngroup,
      ungrouped,
      richTextId,
      richText: {
        content
      }
    } = this.props;
    return /*#__PURE__*/_jsxs(ConfigPanelWrapper, {
      "data-commenting-scroll-container": true,
      children: [/*#__PURE__*/_jsx(ConfigurationPanelHeader, {
        handleDone: this.props.hideConfigurationPanel
      }), /*#__PURE__*/_jsxs(View, {
        padding: "600",
        children: [/*#__PURE__*/_jsx(View, {
          paddingBlockStart: "1200",
          children: /*#__PURE__*/_jsx(Text, {
            as: "h4",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: this.langKey('header')
            })
          })
        }), /*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: this.langKey('label')
          }),
          children: /*#__PURE__*/_jsx(RichTextEditor, {
            id: richTextId,
            config: this.config,
            content: content,
            onChange: this.handleChange
          })
        }), /*#__PURE__*/_jsx(View, {
          paddingBlockStart: "200",
          children: /*#__PURE__*/_jsx(Checkbox, {
            "data-editable": "ungroup-richtext",
            onChange: () => toggleGrouping(richTextId),
            readOnly: !canUngroup,
            checked: ungrouped,
            size: "small",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: this.langKey('ungroup')
            })
          })
        })]
      })]
    });
  }
}
RichTextConfigurationPanel.propTypes = {
  richTextId: PropTypes.string.isRequired,
  richText: PropTypes.object,
  updateRichText: PropTypes.func.isRequired,
  hideConfigurationPanel: PropTypes.bool.isRequired,
  canUngroup: PropTypes.bool.isRequired,
  ungrouped: PropTypes.bool.isRequired,
  toggleGrouping: PropTypes.func.isRequired
};
const mapStateToProps = (state, props) => {
  return {
    richText: getRichText(state, props.richTextId),
    canUngroup: canUngroupRichText(state, props.richTextId),
    ungrouped: getIsRichTextUngrouped(state, props.richTextId)
  };
};
const actionCreators = {
  updateRichText: updateRichTextFromAction,
  toggleGrouping: toggleRichtextUngroup
};
export default connect(mapStateToProps, actionCreators)(RichTextConfigurationPanel);